var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css = "body.no-scroll{height:100%;overflow:hidden!important;position:fixed!important;width:100%}#mydatahelps-survey-modal{background:rgba(0,0,0,.5);bottom:0;left:0;position:fixed;right:0;top:0}#mydatahelps-survey-modal .mydatahelps-survey{background:#fff;border-radius:5px;box-sizing:border-box;height:calc(100% - 32px);margin:16px auto;max-width:768px;overflow:hidden;position:relative;z-index:5002}#mydatahelps-survey-modal .mydatahelps-survey iframe{border:none;bottom:0;height:100%;left:0;opacity:0;position:absolute;right:0;top:0;width:100%}#mydatahelps-survey-modal.loaded .mydatahelps-survey iframe{opacity:1}@media (max-width:768px){#mydatahelps-survey-modal .mydatahelps-survey{border-radius:0;height:100%;margin-bottom:0;margin-top:0}}#mydatahelps-survey-modal .mydatahelps-survey .loader{-webkit-animation:load3 1.4s linear infinite;animation:load3 1.4s linear infinite;background:#fff;background:-moz-linear-gradient(left,#bbb 10%,hsla(0,0%,100%,0) 42%);background:-webkit-linear-gradient(left,#bbb 10%,hsla(0,0%,100%,0) 42%);background:-o-linear-gradient(left,#bbb 10%,hsla(0,0%,100%,0) 42%);background:-ms-linear-gradient(left,#bbb 10%,hsla(0,0%,100%,0) 42%);background:linear-gradient(90deg,#bbb 10%,hsla(0,0%,100%,0) 42%);border-radius:50%;font-size:5px;height:11em;left:calc(50% - 5.5em);position:absolute;text-indent:-9999em;top:calc(50% - 5.5em);-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);width:11em;z-index:1}#mydatahelps-survey-modal .mydatahelps-survey .loader:before{background:#bbb;border-radius:100% 0 0 0;content:\"\";height:50%;left:0;position:absolute;top:0;width:50%}#mydatahelps-survey-modal .mydatahelps-survey .loader:after{background:#fff;border-radius:50%;bottom:0;content:\"\";height:75%;left:0;margin:auto;position:absolute;right:0;top:0;width:75%}#mydatahelps-survey-modal.loaded .mydatahelps-survey .loader{display:none}@-webkit-keyframes load3{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load3{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}";
n(css,{});

// @ts-ignore : let rollup handle CSS injection
class MyDataHelps {
    constructor() {
        this.acceptableParentDomains = [
            'localhost',
            'careevolution.com',
            'internal',
            'b3-deploys.com',
            'mydatahelps.org',
            'platform.joinallofus.org',
            'careevolution.dev',
            'ce.dev',
            'mydatahelps.dev'
        ];
        this.accessTokenRenewalBufferSeconds = 120;
        this.apiBasePath = 'api/v1/delegated/';
        this.unsupportedActions = ["SetHeight", "ResearchKit"];
        this.supportedEvents = ["surveyDidFinish", "applicationDidBecomeVisible", "externalAccountSyncComplete", "tokenWillExpire"];
        this.supportedLanguages = [];
        this.currentMessageID = 1;
        this.messageHandlers = [];
        this.registeredEventHandlers = {};
        this.refreshTokenPromise = null;
        this.standaloneMode = false;
        if (this.handleConnectExternalAccountResponse()) {
            return;
        }
        let mdh = this;
        let applicationHost = getParentOrigin();
        let supportedActions;
        function getParentOrigin() {
            let ancestorOrigins = document.location.ancestorOrigins;
            if (ancestorOrigins && ancestorOrigins[0]) {
                return ancestorOrigins[0];
            }
            return '*';
        }
        function acceptableOrigin(origin) {
            if (origin === '*')
                return true;
            let sourceURL = new URL(origin);
            for (let k = 0; k < mdh.acceptableParentDomains.length; k++) {
                if (sourceURL.hostname === mdh.acceptableParentDomains[k] || sourceURL.hostname.endsWith("." + mdh.acceptableParentDomains[k])) {
                    return true;
                }
            }
            return false;
        }
        function validateWindowMessageOrigin(message) {
            if (mdh.isStandaloneMode() && message.origin === window.location.origin) {
                return true;
            }
            if (applicationHost === "*") {
                return acceptableOrigin(message.origin);
            }
            return message.origin === applicationHost;
        }
        function addActions(actions) {
            for (let action in actions) {
                window.webkit.messageHandlers[action] = window.webkit.messageHandlers[action] || { postMessage: actions[action] };
            }
        }
        function receiveWindowMessage(message) {
            if (!validateWindowMessageOrigin(message)) {
                // todo: this can generate tons of console errors when hosting some apps within webappstep (youtube content, for example )
                console.error("message.origin '" + message.origin + "' is not allowed.");
                throw "message.origin '" + message.origin + "' is not allowed.";
            }
            if (message.data.messageID) {
                mdh.setActionResult(message.data);
            }
            else {
                mdh.triggerEvent(message.data);
            }
        }
        function windowHasAnyActions() {
            for (let action in supportedActions) {
                if (window.webkit.messageHandlers[action]) {
                    return true;
                }
            }
            for (let action in mdh.unsupportedActions) {
                if (window.webkit.messageHandlers[mdh.unsupportedActions[action]]) {
                    return true;
                }
            }
            return false;
        }
        if (!acceptableOrigin(applicationHost)) {
            console.log("Detected unsupported parent origin domain.");
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ResearchKit) {
            // Presence of ResearchKit handler indicates the SDK is being used from within a WebViewStep. For pre-SDK backwards compatiblity,
            // WebViewStep setup registers the following handlers: GetDeviceInfo, DeleteProviderAccount, ConnectExternalAccount
            // ShowParticipantWebVisualizationPDF, ResearchKit
            supportedActions = {
                "GetDelegatedAccessToken": function (data) {
                    window.parent.postMessage({
                        name: 'GetDelegatedAccessToken',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetCurrentSurveyAnswers": function (data) {
                    window.parent.postMessage({
                        name: 'GetCurrentSurveyAnswers',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetStepConfiguration": function (data) {
                    window.parent.postMessage({
                        name: 'GetStepConfiguration',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "CompleteStep": function (data) {
                    window.parent.postMessage({
                        name: 'CompleteStep',
                        messageID: data.messageID,
                        answer: data.answer
                    }, applicationHost);
                }
            };
        }
        else {
            supportedActions = {
                "GetDelegatedAccessToken": function (data) {
                    window.parent.postMessage({
                        name: 'GetDelegatedAccessToken',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetDeviceInfo": function (data) {
                    window.parent.postMessage({ name: 'GetDeviceInfo', messageID: data.messageID }, applicationHost);
                },
                "StartParticipantSurvey": function (data) {
                    window.parent.postMessage({
                        name: 'StartParticipantSurvey',
                        messageID: data.messageID,
                        surveyName: data.surveyName
                    }, applicationHost);
                },
                "OpenExternalLink": function (data) {
                    window.parent.postMessage({ name: 'OpenExternalUrl', url: data }, applicationHost);
                },
                "OpenEmbeddedLink": function (data) {
                    window.parent.postMessage({ name: 'OpenEmbeddedUrl', url: data }, applicationHost);
                },
                "OpenExternalApplication": function (data) {
                    window.parent.postMessage({
                        name: 'OpenApplication',
                        messageID: data.messageID,
                        url: data.url,
                        modal: data.modal
                    }, applicationHost);
                },
                "Dismiss": function () {
                    window.parent.postMessage({ name: 'Dismiss' }, applicationHost);
                },
                "PopNavigation": function () {
                    window.parent.postMessage({ name: 'Back' }, applicationHost);
                },
                "ShowTab": function (data) {
                    window.parent.postMessage({ name: 'ShowTab', tabKey: data }, applicationHost);
                },
                "ShowParticipantDashboard": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantDashboard',
                        dashboardKey: data.dashboardKey,
                        modal: data.modal
                    }, applicationHost);
                },
                "ShowParticipantWebVisualization": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantWebVisualization',
                        visualizationKey: data.visualizationKey,
                        parameters: data.parameters,
                        modal: data.modal
                    }, applicationHost);
                },
                "ShowParticipantWebVisualizationPDF": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantWebVisualizationPDF',
                        visualizationKey: data.visualizationKey,
                        parameters: data.parameters,
                        modal: data.modal,
                        landscape: data.landscape,
                        htmlViewerZoom: data.htmlViewerZoom
                    }, applicationHost);
                },
                "DeleteProviderAccount": function (data) {
                    window.parent.postMessage({
                        name: 'DeleteProviderAccount',
                        messageID: data.messageID,
                        accountID: data.accountID
                    }, applicationHost);
                },
                "ConnectExternalAccount": function (data) {
                    window.parent.postMessage({
                        name: 'ConnectExternalAccount',
                        externalAccountProviderID: data.externalAccountProviderID,
                        messageID: data.messageID,
                        openNewWindow: data.openNewWindow,
                        width: data.width,
                        height: data.height
                    }, applicationHost);
                },
                "ShowProject": function (data) {
                    window.parent.postMessage({ name: 'ShowProject', code: data.code }, applicationHost);
                },
                "JoinProject": function (data) {
                    window.parent.postMessage({ name: 'JoinProject', code: data.code }, applicationHost);
                },
                "GetCurrentSurveyAnswers": function (data) {
                    window.parent.postMessage({
                        name: 'GetCurrentSurveyAnswers',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetStepConfiguration": function (data) {
                    window.parent.postMessage({
                        name: 'GetStepConfiguration',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "CompleteStep": function (data) {
                    window.parent.postMessage({
                        name: 'CompleteStep',
                        messageID: data.messageID,
                        answer: data.answer
                    }, applicationHost);
                }
            };
        }
        if (!window.webkit || !window.webkit.messageHandlers || !windowHasAnyActions()) {
            window.webkit = {
                messageHandlers: {}
            };
        }
        addActions(supportedActions);
        window.addEventListener("message", receiveWindowMessage, false);
    }
    // Surveys
    startSurvey(surveyName) {
        if (this.isStandaloneMode()) {
            this.startDelegatedSurvey(`${this.baseUrl}/survey?surveyName=${encodeURIComponent(surveyName)}`);
        }
        else if (window.webkit.messageHandlers.StartParticipantSurvey) {
            let messageID = this.nextMessageID();
            window.webkit.messageHandlers.StartParticipantSurvey.postMessage({
                messageID: messageID,
                surveyName: surveyName
            });
        }
    }
    completeStep(answer) {
        if (answer === undefined || answer === null)
            answer = '';
        if (typeof answer !== 'string') {
            answer = JSON.stringify(answer);
        }
        if (window.webkit.messageHandlers.ResearchKit) {
            window.webkit.messageHandlers.ResearchKit.postMessage(answer);
        }
        else if (window.webkit.messageHandlers.CompleteStep) {
            let messageID = this.nextMessageID();
            window.webkit.messageHandlers.CompleteStep.postMessage({
                messageID: messageID,
                answer: answer
            });
        }
    }
    querySurveyAnswers(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("surveyName")) {
            queryParameters.surveyName = MyDataHelps.reduceArrayAndEscape(queryParameters.surveyName);
        }
        if (queryParameters.hasOwnProperty("stepIdentifier")) {
            queryParameters.stepIdentifier = MyDataHelps.reduceArrayAndEscape(queryParameters.stepIdentifier);
        }
        if (queryParameters.hasOwnProperty("resultIdentifier")) {
            queryParameters.resultIdentifier = MyDataHelps.reduceArrayAndEscape(queryParameters.resultIdentifier);
        }
        if (queryParameters.hasOwnProperty("answer")) {
            queryParameters.answer = MyDataHelps.reduceArrayAndEscape(queryParameters.answer);
        }
        if (queryParameters.hasOwnProperty("before")) {
            queryParameters.before = MyDataHelps.convertDateToIsoString(queryParameters.before);
        }
        if (queryParameters.hasOwnProperty("after")) {
            queryParameters.after = MyDataHelps.convertDateToIsoString(queryParameters.after);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'surveyanswers?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    deleteSurveyResult(resultID) {
        const endpoint = 'surveyresults/' + encodeURIComponent(resultID);
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'DELETE', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    querySurveyTasks(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("status")) {
            queryParameters.status = MyDataHelps.reduceArrayAndEscape(queryParameters.status);
        }
        if (queryParameters.hasOwnProperty("surveyName")) {
            queryParameters.surveyName = MyDataHelps.reduceArrayAndEscape(queryParameters.surveyName);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'surveytasks?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    startEmbeddedSurvey(linkIdentifier, surveyName, language) {
        if (!language) {
            language = this.getCurrentLanguage();
        }
        let surveyUrl = this.getBaseUrl() + "mydatahelps/" + linkIdentifier + '/surveylink/' + surveyName + "?lang=" + language;
        return this.startEmbeddedSurveyInternal(surveyUrl);
    }
    // Navigation
    openExternalUrl(url) {
        if (window.webkit.messageHandlers.OpenExternalLink) {
            window.webkit.messageHandlers.OpenExternalLink.postMessage(url);
        }
    }
    openEmbeddedUrl(url) {
        if (window.webkit.messageHandlers.OpenEmbeddedLink) {
            window.webkit.messageHandlers.OpenEmbeddedLink.postMessage(url);
        }
    }
    showTab(tabKey) {
        if (window.webkit.messageHandlers.ShowTab) {
            window.webkit.messageHandlers.ShowTab.postMessage(tabKey);
        }
    }
    openApplication(url, options) {
        if (window.webkit.messageHandlers.OpenExternalApplication) {
            let messageID = this.nextMessageID();
            window.webkit.messageHandlers.OpenExternalApplication.postMessage({
                messageID: messageID,
                url: url,
                modal: !!(options && options.modal)
            });
        }
    }
    dismiss() {
        if (window.webkit.messageHandlers.Dismiss) {
            window.webkit.messageHandlers.Dismiss.postMessage({});
        }
    }
    back() {
        if (window.webkit.messageHandlers.PopNavigation) {
            window.webkit.messageHandlers.PopNavigation.postMessage({});
        }
    }
    showDashboard(dashboardKey, options) {
        if (window.webkit.messageHandlers.ShowParticipantDashboard) {
            window.webkit.messageHandlers.ShowParticipantDashboard.postMessage({
                dashboardKey: dashboardKey,
                modal: !!(options && options.modal),
                title: options && options.title ? options.title : undefined
            });
        }
    }
    showWebVisualization(visualizationKey, parameters, options) {
        if (window.webkit.messageHandlers.ShowParticipantWebVisualization) {
            window.webkit.messageHandlers.ShowParticipantWebVisualization.postMessage({
                visualizationKey: visualizationKey,
                parameters: parameters,
                modal: !!(options && options.modal),
                title: options && options.title ? options.title : undefined
            });
        }
    }
    showWebVisualizationPdf(visualizationKey, parameters, options) {
        if (window.webkit.messageHandlers.ShowParticipantWebVisualizationPDF) {
            window.webkit.messageHandlers.ShowParticipantWebVisualizationPDF.postMessage({
                visualizationKey: visualizationKey,
                parameters: parameters,
                landscape: !!(options && options.landscape),
                htmlViewerZoom: options && options.htmlViewerZoom
            });
        }
    }
    showProject(projectCode) {
        if (window.webkit.messageHandlers.ShowProject) {
            window.webkit.messageHandlers.ShowProject.postMessage({ code: projectCode });
        }
    }
    joinProject(projectCode) {
        if (window.webkit.messageHandlers.JoinProject) {
            window.webkit.messageHandlers.JoinProject.postMessage({ code: projectCode });
        }
    }
    //Events
    on(eventName, callback) {
        if (!this.supportedEvents.includes(eventName)) {
            throw new Error(eventName + " is not a supported event type.");
        }
        if (!this.registeredEventHandlers[eventName]) {
            this.registeredEventHandlers[eventName] = [];
        }
        this.registeredEventHandlers[eventName].push(callback);
    }
    off(eventName, callback) {
        if (!this.supportedEvents.includes(eventName)) {
            throw new Error(eventName + " is not a supported event type.");
        }
        if (!this.registeredEventHandlers[eventName])
            return;
        let eventHandlerIndex = this.registeredEventHandlers[eventName].indexOf(callback);
        if (eventHandlerIndex !== -1) {
            this.registeredEventHandlers[eventName].splice(eventHandlerIndex, 1);
        }
    }
    triggerEvent(event) {
        let eventName = event.type;
        if (this.supportedEvents.includes(eventName) && this.registeredEventHandlers[eventName]) {
            this.registeredEventHandlers[eventName].forEach(function (handler) {
                handler(event);
            });
        }
    }
    setActionResult(data) {
        this.messageHandlers[data.messageID](data);
    }
    // Participant Info
    getParticipantInfo() {
        const mdh = this;
        const endpoint = 'participant';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    getProjectInfo() {
        const mdh = this;
        const endpoint = 'project';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // Device Data
    getDeviceDataPoint(id) {
        const endpoint = 'devicedata/' + id;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    deleteDeviceDataPoint(id) {
        const endpoint = 'devicedata/' + id;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'DELETE', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    queryDeviceData(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("type")) {
            queryParameters.type = MyDataHelps.reduceArrayAndEscape(queryParameters.type);
        }
        if (queryParameters.hasOwnProperty("observedBefore")) {
            queryParameters.observedBefore = MyDataHelps.convertDateToIsoString(queryParameters.observedBefore);
        }
        if (queryParameters.hasOwnProperty("observedAfter")) {
            queryParameters.observedAfter = MyDataHelps.convertDateToIsoString(queryParameters.observedAfter);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'devicedata?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    persistDeviceData(deviceDataPoints) {
        const endpoint = 'devicedata';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', deviceDataPoints);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    // External Accounts
    getExternalAccountProviders(search, category, pageSize, pageNumber) {
        let searchParameters = {};
        if (!!search)
            searchParameters.search = search;
        if (!!category)
            searchParameters.category = category;
        if (!!pageSize)
            searchParameters.pageSize = pageSize;
        if (!!pageNumber)
            searchParameters.pageNumber = pageNumber;
        const queryString = new URLSearchParams(searchParameters).toString();
        const endpoint = 'externalaccountproviders?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    connectExternalAccount(externalAccountProviderID, options) {
        return new Promise((resolve, reject) => {
            const messageID = mdh.nextMessageID();
            mdh.messageHandlers[messageID] = function (connectProviderAccountResponse) {
                if (connectProviderAccountResponse && connectProviderAccountResponse.success) {
                    resolve();
                }
                else {
                    reject(connectProviderAccountResponse.errorMessage);
                }
            };
            if (this.standaloneMode) {
                let standaloneModeFinalRedirectPath = (options === null || options === void 0 ? void 0 : options.standaloneModeFinalRedirectPath) || window.location.href;
                const mdh = this;
                // DEV: Safari blocks popups in AJAX responses. Work-around is to open a blank window before the request and set the URL later
                let providerAuthWindow;
                if (options === null || options === void 0 ? void 0 : options.openNewWindow) {
                    standaloneModeFinalRedirectPath = `${standaloneModeFinalRedirectPath.split('?')[0]}?connectExternalAccount=true&messageID=${messageID}&success=%SUCCESSVALUE%`;
                    let windowFeatures = null;
                    if ((options === null || options === void 0 ? void 0 : options.width) && (options === null || options === void 0 ? void 0 : options.height)) {
                        const w = options === null || options === void 0 ? void 0 : options.width;
                        const h = options === null || options === void 0 ? void 0 : options.height;
                        const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
                        const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
                        windowFeatures = "width=" + w + ",height=" + h + ",top=" + y + ",left=" + x;
                    }
                    providerAuthWindow = window.open(`${this.baseUrl}home/loading`, 'providerauth', windowFeatures);
                }
                const searchParameters = { finalRedirectPath: standaloneModeFinalRedirectPath };
                const queryString = new URLSearchParams(searchParameters).toString();
                const endpoint = "externalaccountproviders/" + externalAccountProviderID + "/connect?" + queryString;
                this
                    .connect()
                    .then(function () {
                    return mdh.makeRequest(endpoint, 'POST', null);
                })
                    .then(function (response) {
                    return MyDataHelps.validateResponse(response);
                })
                    .then(function (response) {
                    return response.text();
                })
                    .then(function (redirectUrl) {
                    if (providerAuthWindow) {
                        providerAuthWindow.location = redirectUrl.replace(/['"]+/g, '');
                    }
                    else {
                        window.top.location = redirectUrl.replace(/['"]+/g, '');
                    }
                })
                    .catch(function (error) {
                    reject(error);
                });
            }
            else if (window.webkit.messageHandlers.ConnectExternalAccount) {
                window.webkit.messageHandlers.ConnectExternalAccount.postMessage(Object.assign({ externalAccountProviderID: externalAccountProviderID, messageID: messageID }, options));
            }
        });
    }
    getExternalAccounts() {
        const endpoint = 'externalaccounts';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    refreshExternalAccount(accountID) {
        const endpoint = 'externalaccounts/refresh/' + accountID;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    deleteExternalAccount(accountID) {
        const endpoint = 'externalaccounts/delete/' + encodeURIComponent(accountID);
        const mdh = this;
        if (this.isStandaloneMode()) {
            return this
                .connect()
                .then(function () {
                return mdh.makeRequest(endpoint, 'DELETE', null);
            })
                .then(function (response) {
                return MyDataHelps.validateResponse(response);
            });
        }
        return new Promise(function (resolve, reject) {
            if (window.webkit.messageHandlers.DeleteProviderAccount) {
                const messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (deleteProviderAccountResponse) {
                    if (!deleteProviderAccountResponse.success) {
                        reject(deleteProviderAccountResponse);
                    }
                    else {
                        resolve(deleteProviderAccountResponse);
                    }
                };
                window.webkit.messageHandlers.DeleteProviderAccount.postMessage({
                    messageID: messageID,
                    accountID: accountID
                });
            }
            else {
                reject();
            }
        });
    }
    // Notifications
    queryNotifications(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("sentBefore")) {
            queryParameters.sentBefore = MyDataHelps.convertDateToIsoString(queryParameters.sentBefore);
        }
        if (queryParameters.hasOwnProperty("sentAfter")) {
            queryParameters.sentAfter = MyDataHelps.convertDateToIsoString(queryParameters.sentAfter);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'notifications?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // Fitbit
    queryFitbitDailySummaries(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("startDate")) {
            queryParameters.startDate = MyDataHelps.convertDateToIsoString(queryParameters.startDate);
        }
        if (queryParameters.hasOwnProperty("endDate")) {
            queryParameters.endDate = MyDataHelps.convertDateToIsoString(queryParameters.endDate);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'fitbit/dailySummaries?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    queryFitbitSleepLogs(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("startDate")) {
            queryParameters.startDate = MyDataHelps.convertDateToIsoString(queryParameters.startDate);
        }
        if (queryParameters.hasOwnProperty("endDate")) {
            queryParameters.endDate = MyDataHelps.convertDateToIsoString(queryParameters.endDate);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'fitbit/sleepLogs?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // AppleHealth
    queryAppleHealthActivitySummaries(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("startDate")) {
            queryParameters.startDate = MyDataHelps.convertDateToIsoString(queryParameters.startDate);
        }
        if (queryParameters.hasOwnProperty("endDate")) {
            queryParameters.endDate = MyDataHelps.convertDateToIsoString(queryParameters.endDate);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'appleHealth/activitySummaries?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    queryAppleHealthWorkouts(queryParameters) {
        queryParameters = Object.assign({}, queryParameters);
        if (queryParameters.hasOwnProperty("startDate")) {
            queryParameters.startDate = MyDataHelps.convertDateToIsoString(queryParameters.startDate);
        }
        if (queryParameters.hasOwnProperty("endDate")) {
            queryParameters.endDate = MyDataHelps.convertDateToIsoString(queryParameters.endDate);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'appleHealth/workouts?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // Authorization
    connect() {
        const mdh = this;
        let refreshDelegatedAccessToken = function () {
            mdh.token = null;
            mdh.refreshTokenPromise = new Promise(function (resolve, reject) {
                let messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (tokenResponse) {
                    if (tokenResponse.success) {
                        mdh.tokenExpires = Date.now() + (tokenResponse.data.expires_in * 1000);
                        mdh.token = tokenResponse.data;
                        mdh.baseUrl = tokenResponse.baseUrl;
                        setTimeout(refreshDelegatedAccessToken, ((tokenResponse.data.expires_in - mdh.accessTokenRenewalBufferSeconds) * 1000));
                        resolve(null);
                    }
                    else {
                        mdh.token = null;
                        reject(tokenResponse.message);
                    }
                    mdh.messageHandlers[messageID] = null;
                    mdh.refreshTokenPromise = null;
                };
                window.webkit.messageHandlers.GetDelegatedAccessToken.postMessage({ messageID: messageID });
            });
        };
        if (this.token && Date.now() < this.tokenExpires) {
            return Promise.resolve();
        }
        if (this.isStandaloneMode()) {
            let error = this.token ? "access token is expired or invalid" : "access token must be explicitly provided using the setParticipantAccess method";
            console.log(error);
            return Promise.reject(error);
        }
        if (!this.refreshTokenPromise) {
            refreshDelegatedAccessToken();
        }
        // Re-use promise if refresh already in progress
        return this.refreshTokenPromise;
    }
    setParticipantAccessToken(token, baseUrl) {
        this.enableStandaloneMode();
        this.token = token;
        if (baseUrl) {
            this.baseUrl = baseUrl;
        }
        this.tokenExpires = Date.now() + (this.token.expires_in * 1000);
        const mdh = this;
        setTimeout(function () {
            mdh.triggerEvent({ type: "tokenWillExpire" });
        }, ((this.token.expires_in - this.accessTokenRenewalBufferSeconds) * 1000));
    }
    // Miscellaneous
    isStandaloneMode() {
        return this.standaloneMode;
    }
    enableStandaloneMode() {
        this.standaloneMode = true;
        if (window.webkit) {
            window.webkit.messageHandlers = {};
        }
    }
    setStatusBarStyle(style) {
        if (window.webkit.messageHandlers.SetStatusBarStyle) {
            window.webkit.messageHandlers.SetStatusBarStyle.postMessage({ style: style });
        }
    }
    getDeviceInfo() {
        let mdh = this;
        return new Promise(function (resolve, reject) {
            if (mdh.isStandaloneMode()) {
                resolve(null);
            }
            else if (window.webkit.messageHandlers.GetDeviceInfo) {
                let messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (deviceInfoResponse) {
                    resolve(deviceInfoResponse.data);
                };
                window.webkit.messageHandlers.GetDeviceInfo.postMessage({ messageID: messageID });
            }
            else {
                reject();
            }
        });
    }
    setSupportedLanguages(languages) {
        this.supportedLanguages.length = 0;
        for (let i = 0; i < languages.length; i++) {
            this.supportedLanguages.push(languages[i].replace("_", "-"));
        }
    }
    getStepConfiguration() {
        let mdh = this;
        return new Promise(function (resolve, reject) {
            if (mdh.isStandaloneMode()) {
                resolve(null);
            }
            else if (window.webkit.messageHandlers.GetStepConfiguration) {
                let messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (stepConfigurationResponse) {
                    resolve(stepConfigurationResponse.data);
                };
                window.webkit.messageHandlers.GetStepConfiguration.postMessage({ messageID: messageID });
            }
            else {
                reject();
            }
        });
    }
    getCurrentSurveyAnswers() {
        let mdh = this;
        return new Promise(function (resolve, reject) {
            if (mdh.isStandaloneMode()) {
                resolve(null);
            }
            else if (window.webkit.messageHandlers.GetCurrentSurveyAnswers) {
                let messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (currentSurveyAnswersResponse) {
                    resolve(currentSurveyAnswersResponse.data);
                };
                window.webkit.messageHandlers.GetCurrentSurveyAnswers.postMessage({ messageID: messageID });
            }
            else {
                reject();
            }
        });
    }
    setCurrentLanguage(language) {
        let supportedLanguage = this.getSupportedLanguage(language);
        if (supportedLanguage) {
            this.language = supportedLanguage;
        }
        else {
            console.warn(`language ${language} not supported`);
        }
    }
    getCurrentLanguage() {
        let searchParams = new URLSearchParams(window.location.search);
        let lang;
        if (searchParams.has("lang")) {
            lang = this.getSupportedLanguage(searchParams.get("lang"));
            if (lang) {
                return lang;
            }
            else {
                console.warn(`language ${searchParams.get("lang")} not supported`);
            }
        }
        return this.language || navigator.language;
    }
    showGoogleFitSettings() {
        if (window.webkit.messageHandlers.ShowGoogleFitSettings) {
            window.webkit.messageHandlers.ShowGoogleFitSettings.postMessage({});
        }
    }
    requestReview(cooldownDays) {
        if (window.webkit.messageHandlers.RequestReview) {
            window.webkit.messageHandlers.RequestReview.postMessage({ cooldownDays: cooldownDays });
        }
    }
    trackCustomEvent(event) {
        const endpoint = 'customevents';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', event);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    getDataCollectionSettings() {
        const mdh = this;
        const endpoint = 'datacollectionsettings';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    invokeCustomApi(customApi, method, queryParameters, jsonResponse) {
        if (customApi.includes('?')) {
            throw new Error("Cannot include query parameters directly in the \"customApi\" string. Provide as an argument for \"queryParameters\" instead.");
        }
        let endpoint = 'custom/' + customApi;
        method = method.toUpperCase();
        if (queryParameters !== null && queryParameters !== undefined && (method === 'GET' || method === 'DELETE')) {
            let parameterString = new URLSearchParams(queryParameters).toString();
            endpoint += "?" + parameterString;
            queryParameters = null;
        }
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, method, queryParameters);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return jsonResponse ? response.json() : undefined;
        });
    }
    nextMessageID() {
        return this.currentMessageID++;
    }
    getBaseUrl() {
        return this.baseUrl || 'https://mydatahelps.org/';
    }
    makeUrl(endpoint) {
        if (!this.baseUrl) {
            console.error("Cannot use makeUrl without MyDataHelps.baseUrl.");
            throw "Cannot use makeUrl without MyDataHelps.baseUrl.";
        }
        return this.baseUrl + this.apiBasePath + endpoint;
    }
    makeRequest(endpoint, method, body) {
        if (!this.token || !this.token.access_token) {
            throw "No access_token available for request authorization.";
        }
        let url = this.makeUrl(endpoint);
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + this.token.access_token);
        headers.append('Accept', 'application/json, text/javascript, */*; q=0.01');
        headers.append('Accept-Language', this.getCurrentLanguage());
        if (!!body) {
            headers.append('Content-Type', 'application/json');
        }
        let init = {
            method: method,
            headers: headers
        };
        if (!!body) {
            init.body = JSON.stringify(body);
        }
        return fetch(url, init);
    }
    getSupportedLanguage(language) {
        language = language.replace("_", "-");
        if (this.supportedLanguages.length === 0) {
            return language;
        }
        else {
            if (this.supportedLanguages.find((l) => l === language)) {
                return language;
            }
            else if (language.indexOf("-") > 0) {
                language = language.substring(0, language.indexOf("-"));
                if (this.supportedLanguages.find((l) => l === language)) {
                    return language;
                }
            }
        }
    }
    static validateResponse(response) {
        if (!response.ok) {
            throw response.statusText;
        }
        return response;
    }
    static escapeParam(param) {
        return String(param)
            .replace("\\", "\\\\")
            .replace(",", "\\,");
    }
    static reduceArrayAndEscape(param) {
        if (Array.isArray(param)) {
            let escapedParams = param.map(function (elem) {
                return MyDataHelps.escapeParam(elem);
            });
            return escapedParams.join(",");
        }
        return this.escapeParam(param);
    }
    static convertDateToIsoString(date) {
        let paramAsDate = new Date(date);
        if (isNaN(paramAsDate.getTime())) {
            throw "Cannot interpret parameter as Date";
        }
        return paramAsDate.toISOString();
    }
    startEmbeddedSurveyInternal(surveyUrl) {
        let mdhSurveyModalId = 'mydatahelps-survey-modal';
        let mdh = this;
        return new Promise(function (resolve, reject) {
            if (document.getElementById(mdhSurveyModalId)) {
                reject("Survey already in progress");
                return;
            }
            window.addEventListener("message", function listener(message) {
                if (message.origin !== new URL(mdh.getBaseUrl()).origin) {
                    return;
                }
                let frame = document.getElementById('mydatahelps-survey-frame').contentWindow;
                if (message.source !== frame) {
                    return;
                }
                if (message.data.name === 'SurveyWindowInitialized') {
                    document.getElementById(mdhSurveyModalId).className += " loaded";
                }
                else if (message.data.name === 'SurveyFinished') {
                    document.getElementById(mdhSurveyModalId).remove();
                    document.body.className = document.body.className.replace("no-scroll", "");
                    window.removeEventListener("message", listener, true);
                    resolve(message.data);
                }
            }, true);
            let surveyModal = document.createElement('div');
            surveyModal.className = 'mydatahelps-survey-modal';
            surveyModal.id = mdhSurveyModalId;
            surveyModal.innerHTML = "<div class='mydatahelps-survey'><div class='loader'>Loading...</div><iframe id='mydatahelps-survey-frame' allow='camera' sandbox='allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts' src='" + surveyUrl + "'></iframe></div>";
            document.body.append(surveyModal);
            document.body.className += ' no-scroll';
        });
    }
    startDelegatedSurvey(surveyUrl) {
        let mdhSurveyModalId = 'mydatahelps-survey-modal';
        let mdh = this;
        if (document.getElementById(mdhSurveyModalId)) {
            return;
        }
        window.addEventListener("message", function listener(message) {
            if (message.origin !== new URL(mdh.getBaseUrl()).origin) {
                return;
            }
            let frame = document.getElementById('mydatahelps-survey-frame').contentWindow;
            if (message.source !== frame) {
                return;
            }
            if (message.data.name === 'GetDelegatedAccessToken') {
                mdh.getParticipantInfo().then((participant) => {
                    frame.postMessage({ name: "DelegatedAccessTokenResponse", accessToken: mdh.token, baseUrl: mdh.baseUrl, participantID: participant.participantID }, '*');
                });
            }
            else if (message.data.name === 'SurveyWindowInitialized') {
                document.getElementById(mdhSurveyModalId).className += " loaded";
            }
            else if (message.data.name === 'SurveyFinished') {
                document.getElementById(mdhSurveyModalId).remove();
                document.body.className = document.body.className.replace("no-scroll", "");
                window.removeEventListener("message", listener, true);
                message.data.type = 'surveyDidFinish';
                mdh.triggerEvent(message.data);
            }
        }, true);
        let surveyModal = document.createElement('div');
        surveyModal.className = 'mydatahelps-survey-modal';
        surveyModal.id = mdhSurveyModalId;
        surveyModal.innerHTML = `<div class='mydatahelps-survey'><div class='loader'>Loading...</div><iframe id='mydatahelps-survey-frame' allow='camera' sandbox='allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts' src='${surveyUrl}&lang=${mdh.getCurrentLanguage()}'></iframe></div>`;
        document.body.append(surveyModal);
        document.body.className += ' no-scroll';
    }
    handleConnectExternalAccountResponse() {
        const params = new URLSearchParams(window.location.search);
        if (window.opener && params.get('connectExternalAccount') && params.get('messageID') && params.get('success')) {
            window.opener.postMessage({
                name: 'ConnectExternalAccountResponse',
                messageID: parseInt(params.get('messageID')),
                success: params.get('success') === 'true'
            }, window.location.origin);
            window.close();
            return true;
        }
    }
}
//iOS/Android directly invoke window.MyDataHelps and window.RKStudioClient
//so it's necessary to explicitly ensure they are present on the window
const mdh = new MyDataHelps();
window.MyDataHelps = mdh;
// For backwards compatibility
window.RKStudioClient = {};
window.RKStudioClient.setActionResult = function (data) {
    window.MyDataHelps.setActionResult(data);
};

export { MyDataHelps, mdh as default };
